import type { FaireProductEntity } from "../../entity_types/product";

export const p_s2z7vf4tre: FaireProductEntity = {
  token: "p_s2z7vf4tre",
  type: "product",
  name: "Women’s Hormone Balance",
  brandToken: "b_bacgwqg9jp",
  brandName: "Blaze Herbals",
  imageUrl:
    "https://cdn.faire.com/fastly/bf2c30d0fab79dd42c9e8d37622fd9bb1f02e7cfdeedae44cbcd05dfaa166670.jpeg",
  galleryImageUrls: [],
  priceDollars: 11,
  description:
    "Herbal Tincture for Hormonal Support\n\nWomen’s Hormone Balance is a carefully crafted herbal tincture designed to support hormonal health, balance mood, and promote overall well-being. This blend features powerful adaptogenic and hormone-supporting herbs traditionally used to ease menstrual discomfort, regulate cycles, and enhance vitality.\n\n\n\nKey Ingredients & Benefits\n\n• Yarrow (Achillea millefolium) – Known for its ability to support circulation and reduce menstrual discomfort, yarrow helps regulate cycles and ease bloating.\n\n• Ashwagandha (Withania somnifera) – An adaptogen that helps the body manage stress, ashwagandha supports adrenal health, balances cortisol, and enhances energy.\n\n• Shatavari (Asparagus racemosus) – A renowned Ayurvedic herb for women’s reproductive health, shatavari promotes hormonal balance, fertility, and overall vitality.\n\n• Rhodiola (Rhodiola rosea) – Helps combat fatigue, improves mood, and supports the body’s resilience to stress, making it beneficial for hormonal equilibrium.\n\n• Vitex (Vitex agnus-castus, Chaste Tree Berry) – Supports progesterone production, helps regulate menstrual cycles, and may ease symptoms of PMS and menopause.\n\n\n\nWhy Choose Blaze Herbals?\n\n✓ Made with high-quality, organic herbs\n\n✓ No additives, preservatives, or fillers\n\n✓ Small-batch, handcrafted for potency\n\n\n\nEmpower your wellness journey with nature’s finest hormonal support.\n",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:27.496Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
